import React from 'react';
import { useSelector } from 'react-redux';
import useMenuLogic from '../../../hooks/useMenuLogic';
import MenuItem from './MenuItem';
import LogoutMenuOption from './LogoutMenuOption';

/**
 * DesktopMenu Component
 *
 * Renders a dropdown navigation menu based on user role.
 * It maps through a list of menu items and displays each using the MenuItem component.
 * Includes a logout option.
 *
 * Props:
 * - userRole: string - The role of the current user.
 * - onClose: function - Callback to close the menu.
 * - showMenu: boolean - Determines if the menu is visible.
 */
const DesktopMenu = ({ onClose, showMenu }) => {
  const user = useSelector((state) => state?.auth?.user);
  const userRole = user?.role;
  const { isActive, handleNavigation, filteredMenuItems } = useMenuLogic(userRole, onClose);

  const baseMenuClass = `
   absolute top-20 right-0 mt-6 z-50 w-72 bg-white rounded-xl shadow-md text-black mr-16
   transform transition-all duration-300 ease-out
 `;

  const visibilityClass = showMenu
    ? 'translate-y-0 opacity-100 pointer-events-auto'
    : '-translate-y-2 opacity-0 pointer-events-none';

  const menuClassName = `${baseMenuClass} ${visibilityClass}`.trim();

  return (
    <div className={menuClassName}>
      {filteredMenuItems.map((item) => (
        <MenuItem
          key={item.path}
          copy={item.copy}
          IconComponent={item.Icon}
          active={isActive(item.path)}
          onClick={() => handleNavigation(item.path)}
          className="border-b border-gray-200"
        />
      ))}
      <LogoutMenuOption onClose={onClose} />
    </div>
  );
};

export default DesktopMenu;
